export const text = {
  Keys: "Key",
  AddKey: "Wachtwoord toevoegen",
  KeyFolder: "Key map",
  KeyFolderaddedsuccessfully: "Key map succesvol toegevoegd",
  KeyFolderupdatedsuccessfully: "Key map succesvol bijgewerkt",
  KeyFolderDeletedsuccessfully: "Key map succesvol verwijderd",
};
